module.exports = __webpack_public_path__ + "assets/img/zip.839d61e0.svg";